/**
 * TanStack Query hooks for `salesforce-conversion-sync`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	salesforceConversionSyncQueryKeys,
	type CreateSalesforceConversionSyncBody,
	type ListSalesforceConversionSyncResponse,
	type SalesforceConversionSyncRow,
} from "./api";

export function useSalesforceConversionSyncList(): UseQueryResult<ListSalesforceConversionSyncResponse, Error> {
	return useQuery({
		queryKey: salesforceConversionSyncQueryKeys.list(),
		queryFn: list,
	});
}

export function useSalesforceConversionSyncCreate(): UseMutationResult<SalesforceConversionSyncRow, Error, CreateSalesforceConversionSyncBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: salesforceConversionSyncQueryKeys.all });
		},
	});
}

export function useSalesforceConversionSyncDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: salesforceConversionSyncQueryKeys.all });
		},
	});
}
